import React from 'react'
import links from '../../../config/links'
import options from '../../../config/options'
import HelpButton from '../HelpButton'
import BaseModal from '../modal/BaseModal'
import { useFeedback } from '../../context/FeedbackContext'
import { useTranslation } from '../../../lib/i18n'

function HelpMenu({ modalVisible, onRequestClose }) {
  const privacyNoticeAlertExpiry = new Date(options.privacyNoticeAlertExpiry)
  const { openFeedback } = useFeedback()
  const { t } = useTranslation()

  return (
    <BaseModal
      title={t('nav.helpAndSupport')}
      closeIcon
      isOpen={modalVisible}
      onRequestClose={onRequestClose}
    >
      <HelpButton
        label={t('nav.submitFeedback')}
        onClick={() => {
          openFeedback()
          onRequestClose()
        }}
      />
      <HelpButton url={links.help} isExternalLink label={t('nav.getHelp')} />
      <HelpButton
        url={links.supportGroup}
        isExternalLink
        label={t('nav.contactSupport')}
      />
      <hr />
      <HelpButton
        url={links.privacy}
        isExternalLink
        noticeText={
          new Date() < privacyNoticeAlertExpiry ? t('nav.updated') : null
        }
        label={t('nav.privacyPolicy')}
      />
      <HelpButton
        url={links.contributorTerms}
        isExternalLink
        label={t('nav.contributorTerms')}
      />
      <HelpButton
        url={links.communityGuidelines}
        isExternalLink
        label={t('nav.communityGuidelines')}
      />
    </BaseModal>
  )
}

export default HelpMenu
